import { useState } from "react";
import { useControllerContext } from "../../hooks/controller-context";
import {
  ControllerHeaderButtonWrapper,
  ControllerHeaderTitle,
  ControllerHeaderWrapper,
} from "./style";
import StructureImage from "../structure-image";
import TimerLog from "../timer-log";
import { userSitOutAll } from "../../../../api/tournament";
import { useSetRecoilState } from "recoil";
import { useNavigate, useParams } from "react-router-dom";
import { isGTDType, isDailyType } from "../../../../utils/tournament-type";
import { customDialogState } from "../../../../recoil/custom-dialog.atom";
import { getPointAndSeedDistributionDetail } from "../../../../api/tournament-prize";
import { removeTimer, updateTimer } from "../../../../api/tournament-timer";
import EditTournamentPopup from "../../../tournament/components/edit";
import { TournamentProvider } from "../../../tournament/hook/context";
import { Const } from "../../../../common/const/const";
import { dailyAllPrize } from "../../../../utils/timer";
import { getTournamentTicketPrizeValue } from "../../../../api/tournament-ticket";

const TimerControllerHeader = () => {
  const { timeInfo, data, getData, level } = useControllerContext();
  const { id } = useParams();
  const tournamentId = id?.replace(/[^0-9]/g, "");
  const navigator = useNavigate();

  const [isUpdate, setIsUpdate] = useState(false);
  // 팝업 상태
  const setDialog = useSetRecoilState(customDialogState);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isLogOpen, setIsLogOpen] = useState(false);
  const [isStructureImageOpen, setIsStructureImageOpen] = useState(false);

  const tournamentEnd = async () => {
    if (!data?.timerDto) return;
    try {
      await userSitOutAll(data.id);
      await removeTimer(data?.timerDto?.id);

      // 로컬에 저장한 진행현황 프리셋 삭제
      localStorage.removeItem(`status-preset-${data.id}`);
      navigator("/solution");
    } catch (e) {
      alert("재시도해주세요. ");
      console.error(e);
    }
  };

  const getLevelText = () => {
    if (timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs < 0) return "";
    if (timeInfo.currentLevel?.type === "LEVEL") {
      return `(현재 레벨 LV ${timeInfo.currentLevel.level})`;
    }
    return "(현재 레벨 BREAK)";
  };

  const getTitleText = () => {
    if (data?.isEnd) {
      return "종료된 토너먼트 입니다. ";
    } else if (data?.timerDto === null) {
      return "시작 준비 중. ";
    } else if (data?.timerDto?.isStop) {
      return "일시정지 상태입니다. ";
    } else if (timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs < 0) {
      return "시작 준비 중. ";
    } else {
      return "토너먼트가 진행 중 입니다. ";
    }
  };

  const getButtonText = () => {
    if (timeInfo.elapsedTimeMs && timeInfo.elapsedTimeMs < 0) {
      return "시작하기";
    }

    if (data?.isEnd || !data?.timerDto) {
      return "종료된 토너먼트";
    }

    return "종료하기";
  };

  const handleTimerState = async () => {
    if (!data || !tournamentId || isUpdate) return;
    if (timeInfo.elapsedTimeMs && timeInfo.elapsedTimeMs < 0) {
      // 시작하기
      try {
        if (data?.timerDto?.id) {
          setIsUpdate(true);
          await updateTimer(
            data.timerDto?.id,
            0,
            undefined,
            "토너먼트 수동 시작",
          );
        }
        getData();
      } catch (e: any) {
        if (e.response.status === 404) {
          alert("이미 종료된 게임은 재시작할 수 없습니다. ");
        }
      } finally {
        // 수동 시작 직후 데이터 불러올 때까지 시작되지 않도록
        setTimeout(() => setIsUpdate(false), 1200);
      }
    } else {
      // 종료하기
      if (data?.registerDeadlineLevel >= level && level !== -1) {
        alert("레지마감레벨 이전에는 토너먼트를 종료할 수 없습니다. ");
        return;
      }
      const res = await getPointAndSeedDistributionDetail(+tournamentId);
      const subPrize = await getTournamentTicketPrizeValue();

      // 시상 등수 여부 확인
      if (
        (isGTDType(data.tournamentType) || isDailyType(data.tournamentType)) &&
        res.distributionDetails.length !== data.moneyInChip.length &&
        res.seedDistributionDetails.length !== data.moneyInChip.length
      ) {
        alert("시상되지 않은 등수가 존재하여 종료할 수 없습니다. ");
        return;
      }

      // 데일리 토너먼트 - 시상 가능 최소 래빗 조건 확인
      if (isDailyType(data.tournamentType)) {
        const totalPoint = res.distributionDetails.reduce(
          (acc, item) => (acc += item.resultPoints),
          0,
        );
        const totalSeed = res.seedDistributionDetails.reduce(
          (acc, item) =>
            (acc +=
              item.resultSeeds +
              (item?.resultCarrots || 0) +
              (item?.resultSubPrizes || 0) *
                (subPrize?.find((sub) => sub.id === item.subPrizeId)
                  ?.prizeValue || 0)),
          0,
        );

        // 총 시상 프라이즈
        const totalPrize = totalPoint / Const.POINT_RATE + totalSeed;

        // 시상 가능 최소 프라이즈
        const dailyPrize = Math.ceil(
          dailyAllPrize(data, data.isDiscountExcluded) / 10000,
        );
        const totalMoneyIn = data.moneyInChip.reduce(
          (sum, curr) => (sum += curr.point),
          0,
        );
        const minPrize = Math.round(
          Math.ceil(dailyPrize * (totalMoneyIn / 100)) * 0.9,
        );

        if (totalPrize < minPrize) {
          alert(
            "시상 가능 총 래빗 범위 내로 시상하지 않은 경우 토너먼트 종료가 불가능합니다. \n시상을 수정해 주세요.",
          );
          return;
        }
      }
      // 최종 종료 안내 팝업
      setDialog({
        title: `토너먼트를 종료하고  \n프라이즈 정산으로 이동하시겠습니까?`,
        confirm: tournamentEnd,
      });
    }
  };

  return (
    <ControllerHeaderWrapper>
      {isLogOpen && data && (
        <TimerLog
          tournamentId={data.id}
          setIsLogOpen={setIsLogOpen}
          data={data}
        />
      )}
      {isStructureImageOpen && data && (
        <StructureImage
          data={data}
          onClose={() => setIsStructureImageOpen(false)}
        />
      )}
      {isEditOpen && data && (
        <TournamentProvider>
          <EditTournamentPopup
            onClose={() => setIsEditOpen(false)}
            tournamentId={data.id}
          />
        </TournamentProvider>
      )}
      <ControllerHeaderTitle>
        <div className="title">
          {getTitleText()} {getLevelText()}
        </div>
        <div>토너먼트 ID: {data?.id}</div>
      </ControllerHeaderTitle>
      <ControllerHeaderButtonWrapper>
        <div
          className="button"
          onClick={() => setIsStructureImageOpen(!isStructureImageOpen)}
        >
          스트럭쳐 다운
        </div>
        <div className="button" onClick={() => setIsLogOpen(!isLogOpen)}>
          전체 로그
        </div>
        <div className="button gray" onClick={() => setIsEditOpen(!isEditOpen)}>
          수정하기
        </div>
        <div
          className={`button ${
            timeInfo.elapsedTimeMs && timeInfo.elapsedTimeMs < 0
              ? "green"
              : "end"
          }`}
          onClick={handleTimerState}
        >
          {getButtonText()}
        </div>
      </ControllerHeaderButtonWrapper>
    </ControllerHeaderWrapper>
  );
};

export default TimerControllerHeader;
